module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('district-blank-form', {
    attrs: {
      "submit-label": "Добавить район",
      "district": _vm.district,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processDistrictForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62d53078","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/district/DistrictAddForm.vue
// module id = 660
// module chunks = 0